<p>dgitl operator dashboard works!</p>